module.exports = __webpack_public_path__ + "static/img/CHICAGO_OAK.bc5f30d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/CHICAGO_OAK.jpg
// module id = zSPk
// module chunks = 0